<template>
  <div class="">
    <template v-if="!(originCityList && originCityList.length)">
      <el-alert type="error" title="请先在'基本信息'栏选择【起运城市】" />
    </template>
    <template v-else>
      <div class="box-item">
        <div class="box-item--label ">起运城市</div>
        <div class="box-item--content">
          <el-select v-model="cityRegionHeaderItem.cityList"
                     @change="changeCityList"
                     style="height: 40px"
                     value-key="id"
                     multiple
                     clearable
                     filterable
                     size="small"
                     class="edit-form__input"
                     placeholder="请选择"
                     :disabled="disabled">
            <el-option
              v-for="(item, index) in unSelectedCityList"
              :key="item.id"
              :label="item.cityName"
              :value="item"
            ></el-option>
          </el-select>
        </div>
      </div>
      <template v-if="!(cityRegionHeaderItem.cityList && cityRegionHeaderItem.cityList.length)">
        <el-alert type="error" title="请先选择【起运城市】" />
      </template>
      <template v-else>
        <!--<br/>-->
        <div class="box-item">
          <!--      <div class="box-item&#45;&#45;label is-required"></div>-->
          <div class="box-item--content">
            <el-checkbox
              v-model="cityRegionHeaderItem.isSupportMultiGoodsTypePrice"
              @input="changeMultiGoodsTypePrice"
              :true-label="1"
              :false-label="0"
              :disabled="disabled"
              size="small">是否支持多产品分类报价</el-checkbox>
          </div>
        </div>
        <br/>
        <div class="box-item">
          <div class="box-item--content">
            <template v-for="(item,index) in cityRegionHeaderItem.cityList">
              <template v-if="startCitySettingWarehouseParams[`${item.id}`]">
                <div class="box-item" :key="`${item.id}_pickUpFlag`">
                  <div class="box-item--label">{{item.cityName}}是否支持免费上门提货</div>
                  <div class="box-item--content">
                    <!--<el-radio-group v-model="item.pickUpFlag" size="mini" :disabled="startCitySettingWarehouseParams[`${item.id}`].platformShareWarehouseFlag === true">
                      <el-radio-button :label="true">是</el-radio-button>
                      <el-radio-button :label="false">否</el-radio-button>
                    </el-radio-group>-->
                    <el-select
                      v-model="item.pickUpFlag"
                      :disabled="startCitySettingWarehouseParams[`${item.id}`].platformShareWarehouseFlag === true || disabled"
                      class="edit-form__input"
                      size="small">
                      <el-option :value="true" label="是">是</el-option>
                      <el-option :value="false" label="否">否</el-option>
                    </el-select>
                  </div>
                </div>
                <div class="box-item" :key="`${item.id}_receiveWarehouseId`" v-if="!startCitySettingWarehouseParams[`${item.id}`].platformShareWarehouseFlag">
                  <div class="box-item--label is-required">{{item.cityName}}送货到仓</div>
                  <div class="box-item--content">
                    <el-select v-model="item.receiveWarehouseId"
                               size="small"
                               class="edit-form__input "
                               :disabled="disabled"
                               placeholder="请选择收货仓库">
                      <el-option
                        v-for="(item, index) in startCitySettingWarehouseParams[`${item.id}`].warehouseList || []"
                        :key="index"
                        :label="item.namec"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
              </template>
              <template v-else-if="startCitySettingWarehouseParamsLoading[`${item.id}`]">
                {{item.cityName}}相关数据正在获取...
              </template>
              <template v-else>
                {{item.cityName}}缺失可选送仓数据...
              </template>
              <br/>
            </template>
          </div>
        </div>
        <br/>
        <template v-if="!(goodsTypeList && goodsTypeList.length)">
          <el-alert type="error" title="请先在'基本信息'栏选择【可走货物类型】" />
        </template>
        <template v-else>
          <slot></slot>
        </template>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  name: "cityRegion",
  props:{
    cityRegionHeaderItem:{// 城市维度分区item
      type:Object,
      default:()=>({}),
    },
    originCityList:{//原始的供选择的起运城市列表
      type:Array,
      default:[],
    },
    unSelectedCityList:{//可选择的起运城市列表
      type:Array,
      default:[],
    },
    goodsTypeList:{//供选择的货物类型列表
      type:Array,
      default:[],
    },
    // 供应商对应收货仓库信息
    startCitySettingWarehouseParams:{
      type:Object,
      default:()=>({}),
    },
    // 供应商对应收货仓库信息请求状态
    startCitySettingWarehouseParamsLoading:{
      type:Object,
      default:()=>({}),
    },
    disabled: {
      type:Boolean,
      default:false,
    }
  },
  methods:{
    /**
     * 改变 起运城市
     */
    changeCityList(val){
      this.$emit("changeCityValue",val);
      // let labelText = val.map(v=>v.cityName).join(",");
      // if(!labelText) labelText = "请选择城市";
      // this.cityRegionHeaderItem.label = labelText;
    },
    /**
     * 改变 是否支持多产品分类报价
     */
    changeMultiGoodsTypePrice(value){
      this.$emit("changeMultiGoodsTypePrice",value);
    },
  },
}
</script>

<style scoped lang="scss">
@import "../boxItem";
</style>



// WEBPACK FOOTER //
// src/components/QuotationManagement/components-productQuotation/cityRegion/index.vue